<template>
  <div class="settings-nav mb-4 mb-md-0 mx-auto text-center">
    <div style="margin-bottom:30px" class="">
      <div class="circle">{{ user.displayName.slice(0, 2) }}</div>
      <div style="text-align:center; font-size:20px">
        {{ user.displayName }}
      </div>
      <div style="text-align:center; font-size:15px;">
        {{ user.email }}
      </div>
      <div></div>
    </div>
    <b-list-group>
      <!-- <b-list-group-item
        id="hyperDashboardOverviewLink"
        :to="'/settings/subscription/' + $route.params.id + '/overview'"
        >Overview</b-list-group-item
      > -->
      <!-- <b-list-group-item
        id="hyperDashboardGeofencemanagerLink"
        :to="'/settings/subscription/' + $route.params.id + '/geofencemanager'"
        >Geofence Manager</b-list-group-item
      > -->
      <b-list-group-item
        id="hyperDashboardimportjob"
        :to="'/settings/jobs/' + $route.params.id + '/jobs'"
        >Jobs</b-list-group-item
      >
      <b-list-group-item
        style="margin-bottom:30px;"
        id="hyperDashboardimportjobsLink"
        :to="'/settings/subscription/' + $route.params.id + '/importjobs'"
        >Import Jobs</b-list-group-item
      >
    </b-list-group>
    <span class="mt-3" style="font-size:12px; color:#495057"
      >Select Subscription</span
    >
    <b-form-select
      v-model="selectedSubscriptionId"
      :options="subscriptionIdOptions"
      @input="navigateToSubscriptionId(selectedSubscriptionId)"
    >
    </b-form-select>
  </div>
</template>

<script>
import router from "../modules/router";
import constants from "../modules/constants";
import { mapGetters } from "vuex";
import { isArray } from "util";
export default {
  data() {
    return {
      selectedSubscriptionId: this.$route.params.id,
      settings: {
        displayName: "",
        photoURL: "",
        initialImage: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      subscriptions: "getSubscriptions",
      user: "getUser"
    }),
    subscriptionIdOptions() {
      if (!isArray(this.subscriptions)) {
        return null;
      }
      if (this.subscriptions.length <= 0) {
        return null;
      } else {
        let optionsArray = [];
        for (let i = 0; i < this.subscriptions.length; i++) {
          let subscriptionItem = this.subscriptions[i];
          if (
            subscriptionItem.id === null ||
            subscriptionItem.id === undefined
          ) {
            continue;
          }
          optionsArray.push({
            value: subscriptionItem.id,
            text:
              subscriptionItem.metadata["friendly_name"] || subscriptionItem.id
          });
        }
        return optionsArray;
      }
    }
  },
  mounted() {
    this.settings.displayName = this.user.displayName;
    this.settings.photoURL =
      this.user.photoURL || constants.profile.default_user_image;
    this.settings.initialImage =
      this.user.photoURL || constants.profile.default_user_image;
  },
  methods: {
    navigateToSubscriptionId(selectedSubscriptionId) {
      if (selectedSubscriptionId !== this.$route.params.id) {
        this.$store.dispatch(
          "updateCurrentDashboardSubscriptionId",
          selectedSubscriptionId
        );
        //https://stackoverflow.com/questions/4758103/last-segment-of-url
        let currentLastPath = this.$route.path.substr(
          this.$route.path.lastIndexOf("/")
        );
        router.replace(
          "/settings/subscription/" + selectedSubscriptionId + currentLastPath
        );
        // router.go();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.settings-nav {
  top: 2rem;
  position: sticky;
}
.circle {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  font-size: 20px;
  color: #fff;
  line-height: 70px;
  text-align: center;
  background: #00a8ff;
  box-shadow: 5px 10px;
  margin: auto;
}
</style>
<style>
.artibot-wrapper--19YJW {
  display: none;
}
</style>
